import React, { Component } from "react";
import PropTypes from "prop-types";
import YesNoModal from "../../../../../shared/components/modals/YesNoModal";

class NoTeesModal extends Component {
  render() {
    const { isOpen, onClose } = this.props;
    return (
      <YesNoModal
        onConfirm={onClose}
        onAbort={onClose}
        isNoVisible={false}
        isOpen={isOpen}
        yesTitle="Close"
      >
        <p>No Tees Available</p>
      </YesNoModal>
    );
  }
}

NoTeesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NoTeesModal;
